module.exports = __webpack_public_path__ + "img/52.4fa62eb1.jpg";